import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const FunnelFillIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M28.4762 8.345L28.4662 8.35625L20 17.3962V24.3325C20.0005 24.6624 19.9194 24.9873 19.7639 25.2782C19.6084 25.5692 19.3833 25.8171 19.1087 26L15.1087 28.6675C14.8073 28.8683 14.457 28.9834 14.0952 29.0007C13.7335 29.0179 13.3738 28.9366 13.0546 28.7654C12.7355 28.5942 12.4688 28.3396 12.283 28.0286C12.0973 27.7177 11.9995 27.3622 12 27V17.3962L3.53375 8.35625L3.52375 8.345C3.26343 8.05852 3.09184 7.70265 3.0298 7.32057C2.96775 6.93849 3.01792 6.54661 3.17421 6.19248C3.3305 5.83835 3.58619 5.53718 3.91028 5.32551C4.23436 5.11384 4.61291 5.00076 5 5H27C27.3874 5.00004 27.7665 5.11259 28.0911 5.32398C28.4158 5.53536 28.672 5.83649 28.8288 6.19077C28.9855 6.54504 29.036 6.93722 28.9741 7.31965C28.9122 7.70207 28.7405 8.05828 28.48 8.345H28.4762Z" />
  </svg>
);

FunnelFillIcon.propTypes = iconPropTypes;

export default FunnelFillIcon;
